// removed by extract-text-webpack-plugin
module.exports = {"box":"BoxShell__box___3zHV-","box-dark":"BoxShell__box-dark___3-NjI BoxShell__box___3zHV-","flash":"BoxShell__flash___IBHwy"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Shells/BoxShell.scss
// module id = 562
// module chunks = 0